import { MessageSquare } from "lucide-react";
import { FC, useState } from "react";
import { SendNotification } from "./send-communication";
import { TableCommunication } from "./table-communication";

type Props = {};

export const Communication: FC<Props> = () => {
  const [showSendForm, setShowSendForm] = useState(false);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-medium">Communication History</h3>
        <button
          onClick={() => setShowSendForm(!showSendForm)}
          className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center space-x-1"
        >
          <MessageSquare size={16} />
          <span>{showSendForm ? 'Hide Form' : 'Send Message'}</span>
        </button>
      </div>

      {showSendForm && <SendNotification />}

      <TableCommunication />
    </div>
  );
};
